<template>
  <div class="bg_gray">
    <top-header :type="6" hasBorder="true" placeholder="商品房购房评价" fontSize="0.32rem" />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner" v-for="(item, index) in list" :key="index">
            <div class="top m_flex_box flex_vc flex_jz">
              <h4 class="line_comp1">{{ item.param1.ItemName }}</h4>
              <i v-show="item.param1.Flag === '0'" class="bg_ori">已备案</i>
              <i v-show="item.param1.Flag === '1'" class="bg_ori">注销中</i>
              <i v-show="item.param1.Flag === '2'" class="bg_ori">已注销</i>
              <i v-show="item.param1.Flag === '3'" class="bg_ori">已网签</i>
            </div>
            <div class="middle">
              <div class="row">{{ item.param1.area |
              format()
              }}<i>|</i>{{ item.param1.BuildingName }}-{{ item.param1.UnitNo }}-{{ item.param1.HouseNo }}<i>|</i>{{
                item.param1.MapHousenUse }}<i>|</i>{{ item.param1.BuArea }}m²
              </div>
              <div class="row_light">合同流水号：{{ item.param1.ContractRecordNo }}</div>
              <div class="row_light">备案日期：{{ item.param1.TRecordTime | format2() }}</div>
            </div>
            <div class="btn_con m_flex_box flex_vc flex_he">
              <span @click="toUrl('/myArgumentList', { index: index })">我的评价</span>
              <span @click="toUrl('/argumentSubmit', { itemId: item.param2.id, path: $route.path })">我要点评</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      formData: {
        currPageNo: 1,
      }
    };
  },
  components: {
    topHeader
  },

  filters: {
    format(data) {
      if (data === "320302000000") {
        return "鼓楼区";
      } else if (data === "320311000000") {
        return "泉山区";
      } else if (data === "320303000000") {
        return "云龙区";
      } else if (data === "320398000000") {
        return "金山桥";
      } else if (data === "320312000000") {
        return "铜山区";
      } else if (data === "320305000000") {
        return "贾汪区";
      } else if (data === "320399000000") {
        return "高新区";
      } else if (data === "320397000000") {
        return "港务区";
      } else if (data === "320382000000") {
        return "邳州市";
      } else if (data === "320381000000") {
        return "新沂市";
      } else if (data === "320321000000") {
        return "丰县";
      } else if (data === "320324000000") {
        return "睢宁";
      } else if (data === "320322000000") {
        return "沛县";
      } else if (data === "320") {
        return "市区";
      }
    },
    format2(data) {
      if (data) {
        return data.substring(0, 10);
      } else {
        return "-";
      }
    },
  },

  mounted() { },
  methods: {
    toUrl(path, query) {
      this.$router.push({
        path,
        query
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.$set(this, 'list', [])
      this.onLoad(1);
    },

    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 100)
        this.$http({
          url: 'cms/sPFContractBuyerArea/reg/getMyEvaluateContractPageByOffset.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            pageSize: 10,
            offset: (this.formData.currPageNo - 1) * 10,
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.$set(this.formData, 'currPageNo', this.formData.currPageNo + 1)
          } else {
            this.finished = true;
          }
        })
      }
    },

  },
};
</script>
<style lang="less" scoped>
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.inner {
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.16rem solid #f5f5f5;

  .top {
    h4 {
      font-size: 0.32rem;
      font-weight: 800;
    }

    i {
      width: 0.78rem;
      line-height: 0.32rem;
      height: 0.32rem;
      color: #fff;
      font-size: 0.2rem;
      text-align: center;

      &.bg_ori {
        background-color: #FF5C3C;
      }

      &.bg_gra {
        background-color: #A0A0A0;
      }
    }
  }

  .middle {
    padding: 0.2rem 0 0.1rem;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;

    .row {
      margin-bottom: 0.16rem;

      i {
        margin: 0 0.1rem;
      }
    }

    .row_light {
      margin-bottom: 0.16rem;
      color: #666666;
    }
  }

  .btn_con {
    height: 1.08rem;
    padding: 0.25rem 0.23rem;
    box-sizing: border-box;

    span {
      height: 0.58rem;
      width: 1.4rem;
      text-align: center;
      line-height: 0.58rem;
      box-sizing: border-box;
      border: 1px solid #2F72F5;
      color: #2F72F5;
      border-radius: 0.08rem;
      margin-left: 0.14rem;
    }
  }
}
</style>